// App version - updated during release process
export const APP_VERSION = "1.1.12";
